export const mutations = {
    set_unidades(state, data) {
        state.unidades_ = data
    },
    set_marcas(state, data) {
        state.marcas_ = data
    },
    set_producto_seleccionado(state, data) {
        state.producto_seleccionado = data
    },
    set_proveedores(state, data) {
        state.proveedores_ = data
    },
    set_productos(state, data) {
        state.lista_productos = data
    },
    set_formulas(state, data) {
        state.lista_formulas = data
    },
    set_objeto_busqueda(state, data) {
        state.objeto_busqueda = data
    },
    set_datos_modificacion_busqueda(state, data) {
        state.objeto_busqueda.precio_costo = data.precio_costo
        state.objeto_busqueda.precio_venta = data.precio_venta
        state.objeto_busqueda.precio_efectivo = data.precio_efectivo
    },
    set_modal_cambio_precios(state, data) {
        state.modal_cambio_precios = data
    },
    set_materiales(state, data) {
        state.materiales = data
    },
    set_item_merma(state, data) {
        state.item_merma = data
    },
    set_maquinas(state, data) {
        state.maquinas = data
    },
    set_tipos_de_rollo(state, data) {
        state.tipos_de_rollo = data
    },
    set_motivos_salidas(state, data) {
        state.motivos_salida = data
    },
    set_motivo_seleccionado(state, data) {
        state.motivo_seleccionado = data
    },
    set_vendedores(state, data) {
        state.vendedores = data
    },
    set_obj_solicitudes_descuento_admon(state, data) {
        state.obj_solicitudes_descuento_admon = data
    },
    set_filtro_sucursal_promociones(state, data) {
        state.filtro_sucursal_promociones = data
    },
    set_filtro_productos_sucursales_traslados(state, data) {
        state.filtro_productos_sucursales_traslados = data
    },
    set_nombre_empresa_seleccionada(state, data) {
        state.nombre_empresa_seleccionada = data
    },
    set_motivos_entrada(state, data) {
        state.motivos_entrada = data
    },
    set_modal_buscar_productos(state, data) {
        state.modal_buscar_productos = data
    },
    set_articulo_busqueda_seleccionado(state, data) {
        state.articulo_busqueda_seleccionado = data
    },
}
